import React, {createContext, ReactNode, useContext, useId, useState} from 'react';

type TFirstModule = {
	/** True for the first caller only (by `useId`: the same on the server and on the client, also with Strict Mode). */
	claim: (id: string) => boolean;
};

const FirstModuleContext = createContext<TFirstModule | null>(null);

/**
 * Marks the first module of a CMS page: its first image is the LCP candidate (`priority` of `Picture`).
 */
export const FirstModuleProvider = ({children}: {children: ReactNode}) => {
	const [firstModule] = useState<TFirstModule>(() => {
		let owner: string | null = null;

		return {
			claim: (id) => {
				owner ??= id;

				return owner === id;
			},
		};
	});

	return <FirstModuleContext value={firstModule}>{children}</FirstModuleContext>;
};

/**
 * True for the first image (in render order, the same on the server and during hydration) of the first module.
 */
export const useIsFirstModuleImage = (): boolean => {
	const firstModule = useContext(FirstModuleContext);
	const id = useId();

	return !!firstModule && firstModule.claim(id);
};
